document.querySelector('.js-search_btn').addEventListener('click', function () {
  document.querySelector('.js-search_area').classList.toggle('is-active');
  document.querySelector('.page-overlay').classList.toggle('is-active');

  // スクロールの制御
  if (document.querySelector('.js-search_area').classList.contains('is-active')) {
    document.body.style.overflow = 'hidden';

    // 検索エリアがアクティブになったら、検索入力フィールドにフォーカス
    setTimeout(function () {
      const searchInput = document.querySelector('.js-input-search');
      if (searchInput) {
        searchInput.focus();
      }
    }, 100); // 少し遅延を入れて、アニメーション完了後にフォーカス
  } else {
    document.body.style.overflow = '';
  }
});

document.querySelector('.js-search_close').addEventListener('click', function () {
  document.querySelector('.js-search_area').classList.remove('is-active');
  document.querySelector('.page-overlay').classList.remove('is-active');
  document.body.style.overflow = '';
});

// スライドアニメーション機能
function slideToggle(element, duration = 300) {
  if (!element) return;

  const isOpen = element.classList.contains('is-active');

  if (isOpen) {
    // 閉じる
    element.style.maxHeight = element.scrollHeight + 'px';
    element.offsetHeight; // 強制的に再描画
    element.style.maxHeight = '0px';
    element.style.overflow = 'hidden';
    element.style.transition = `max-height ${duration}ms ease-out`;

    setTimeout(() => {
      element.classList.remove('is-active');
      element.style.maxHeight = '';
      element.style.overflow = '';
      element.style.transition = '';
    }, duration);
  } else {
    // 開く
    element.classList.add('is-active');
    element.style.maxHeight = '0px';
    element.style.overflow = 'hidden';
    element.style.transition = `max-height ${duration}ms ease-out`;

    setTimeout(() => {
      element.style.maxHeight = element.scrollHeight + 'px';
    }, 10);

    setTimeout(() => {
      element.style.maxHeight = '';
      element.style.overflow = '';
      element.style.transition = '';
    }, duration);
  }
}

// ソートオプションのテキスト置換（「ベストセラー」→「人気順」）
function replaceSortOptionText() {
  let replaced = false;
  
  // すべてのselectエレメント内のoptionを検索
  const options = document.querySelectorAll('option');
  options.forEach(option => {
    const text = option.textContent.trim();
    // デバッグ: コンソールにオプションテキストを出力
    if (text.includes('Selling') || text.includes('セラー') || text.includes('人気') || text.includes('並び')) {
      console.log('Detected Sort Option:', text, 'Value:', option.value);
    }
    
    if (text === 'Best Selling') {
      console.log('Replacing "Best Selling" with "人気順"');
      option.textContent = '人気順';
      replaced = true;
    } else if (text === 'ベストセラー') {
      console.log('Replacing "ベストセラー" with "人気順"');
      option.textContent = '人気順';
      replaced = true;
    }
  });

  // SortByセレクト（デスクトップ）
  const sortBySelect = document.getElementById('SortBy');
  if (sortBySelect) {
    Array.from(sortBySelect.options).forEach(opt => {
      const text = opt.textContent.trim();
      if (text === 'Best Selling' || text === 'ベストセラー') {
        console.log('Replacing in SortBy:', text, '→ 人気順');
        opt.textContent = '人気順';
        replaced = true;
      }
    });
  }

  // SortBy-mobileセレクト
  const sortByMobileSelect = document.getElementById('SortBy-mobile');
  if (sortByMobileSelect) {
    Array.from(sortByMobileSelect.options).forEach(opt => {
      const text = opt.textContent.trim();
      if (text === 'Best Selling' || text === 'ベストセラー') {
        console.log('Replacing in SortBy-mobile:', text, '→ 人気順');
        opt.textContent = '人気順';
        replaced = true;
      }
    });
  }

  if (replaced) {
    console.log('✓ Sort option text replacement completed');
  }
}

// DOMContentLoaded後に実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', replaceSortOptionText);
} else {
  replaceSortOptionText();
}

// facet-filters-formが追加された時も実行（動的に追加される場合対応）
// debounceで過度な実行を防止
let debounceTimer;
const observer = new MutationObserver(() => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    replaceSortOptionText();
  }, 100);
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: false,
});
